import { Destination } from "../../../Constant/destination"
import { Source } from "../../../Constant/source"

export const createTemplateContents = (language) => {
    return [
        {
            name: 'Meta CAPI',
            source: Source.js,
            destination: Destination.fbcapi,
            logo: '/assets/images/typeImages/facebook-icon.png',
            title: language?.home_page?.metacapi?.title|| 'Create Meta CAPI',
            description: language?.home_page?.metacapi?.description || 'Send your web and app data directly to Meta platforms using the Conversion API (CAPI). Improve the accuracy of your ad campaigns and optimize conversion rates.'
        },
        {
            name: 'Offline Events API',
            source: Source.capi,
            destination: null,
            logo: '/assets/images/typeImages/offline-icon.png',
            title: language?.home_page?.offlineEventsApi?.title || 'Create Offline CAPI',
            description: language?.home_page?.offlineEventsApi?.description || 'Integrate your offline event data with advertising platforms to link offline conversions with your digital ad campaigns. Track customer interactions across all touchpoints comprehensively.',
        },
        {
            name: 'Zoho Conversion Lead',
            source: Source.zoho,
            destination: Destination.fbcapi,
            logo: '/assets/images/typeImages/zoho.png',
            title: language?.home_page?.zohoConversionLead?.title || 'Create ZOHO Conversion Lead',
            description: language?.home_page?.zohoConversionLead?.description || 'Integrate Meta conversions with ZOHO CRM for more effective lead tracking and reporting. Optimize your marketing and sales processes.',
        },
        {
            name: 'TikTok Web Events API',
            source: Source.js,
            destination: Destination.ttcapi,
            logo: '/assets/images/typeImages/tiktok-icon.png',
            title: language?.home_page?.tiktokWebEventsApi?.title || 'Create TikTok Web Events API',
            description: language?.home_page?.tiktokWebEventsApi?.description || 'Send your website events directly to TikTok Web Events API to improve event tracking, attribution quality, and campaign optimization.',
        },
        {
            name: 'Web2App With Adjust',
            source: Source.adjust,
            destination: null,
            isDestinationOptional: true,
            logo: '/assets/images/typeImages/adjust.png',
            title: language?.home_page?.web2appAdjust?.title || 'Create Web2App With Adjust',
            description: language?.home_page?.web2appAdjust?.description || 'Create a Web2App flow using Adjust as the mobile measurement partner. Redirect users from web landing pages to your mobile app while tracking campaign and conversion performance.',
        },
        {
            name: 'Web2App With Appsflyer',
            source: Source.appsflyer,
            destination: null,
            isDestinationOptional: true,
            logo: '/assets/images/typeImages/appsflyer.png',
            title: language?.home_page?.web2appAppsflyer?.title || 'Create Web2App With Appsflyer',
            description: language?.home_page?.web2appAppsflyer?.description || 'Create a Web2App flow using AppsFlyer as the mobile measurement partner. Build landing pages, redirect users to the app, and track web-to-app campaign performance.',
        }
    ]
};